import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getSummary, getDadosDashboard } from './dashboardActions';
import Content from '../common/template/content';
import ModernValueBox from '../common/widget/modernValueBox';
import Row from '../common/layout/row';
import { Panel, Modal } from 'react-bootstrap';
import GraficoContagemLaco from '../contagem/graficoContagemLaco';
import GraficoContagemControlador from '../contagem/graficoContagemControlador';
import { toastr } from 'react-redux-toastr';
import Button from '../common/form/button';
import moment from 'moment';
import LabelAndInputChange from '../common/form/labelAndInputChange';
import '../common/form/form.css';
import './dashboard.css';
import { getContagemGraficoList } from '../contagem/contagemActions';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';
import SelectConfControlador from '../common/selectdb/selectConfControlador';
import '../common/selectdb/contentHeaderFilter.css';
import { getConfig } from '../configuracao/configLocal';

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalControladores: 0,
      totalVeiculos: 0,
      totalAlertas: 0,
      loop: 0,
      showFiltro: false,
      filtroAux: {
        dataInicial: moment().format('YYYY-MM-DD'),
        dataFinal: moment().format('YYYY-MM-DD'),
      },
      filtro: {
        dataInicial: moment().format('YYYY-MM-DD'),
        dataFinal: moment().format('YYYY-MM-DD'),
      },
    };
    this.intervalValorDashboard = 0;

    this.aplicarFiltro = this.aplicarFiltro.bind(this);
    this.valuesDashboard = this.valuesDashboard.bind(this);
    this.handleCloseFiltro = this.handleCloseFiltro.bind(this);
    this.handleShowFiltro = this.handleShowFiltro.bind(this);
    this.onChangeDataInicial = this.onChangeDataInicial.bind(this);
    this.onChangeDataFinal = this.onChangeDataFinal.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.changeControlador = this.changeControlador.bind(this);
    this.handleAlertasClick = this.handleAlertasClick.bind(this);
  }

  aplicarFiltro() {
    let filtroTela = this.state.filtroAux;

    let filtroNovo = this.state.filtro;
    filtroNovo.dataInicial = filtroTela.dataInicial;
    filtroNovo.dataFinal = filtroTela.dataFinal;

    this.handleCloseFiltro();

    this.props.getContagemGraficoList(this.state.filtro).then(result => {});
  }

  componentWillMount() {
    this.props.getSummary();
    this.valuesDashboard();
  }

  componentWillUnmount() {
    clearInterval(this.intervalValorDashboard);
  }

  handleCloseFiltro() {
    this.setState({
      showFiltro: false,
    });
  }

  handleShowFiltro() {
    this.setState({
      showFiltro: true,
    });
  }

  onChangeDataInicial(event) {
    let filtroAux = this.state.filtroAux;
    filtroAux.dataInicial = event.target.value;
    this.setState({ filtroAux: filtroAux });
  }

  onChangeDataFinal(event) {
    let filtroAux = this.state.filtroAux;
    filtroAux.dataFinal = event.target.value;
    this.setState({ filtroAux: filtroAux });
  }

  limparFiltro() {
    let filtroNovo = this.state.filtro;
    filtroNovo.dataInicial = moment().format('YYYY-MM-DD');
    filtroNovo.dataFinal = moment().format('YYYY-MM-DD');
    this.setState({ filtro: filtroNovo });

    let filtroNovoAux = this.state.filtroAux;
    filtroNovoAux.dataInicial = moment().format('YYYY-MM-DD');
    filtroNovoAux.dataFinal = moment().format('YYYY-MM-DD');
    this.setState({ filtroAux: filtroNovoAux });

    this.props.getContagemGraficoList(this.state.filtro).then(result => {});
  }

  changeControlador() {
    this.props.getContagemGraficoList(this.state.filtro);
    // Atualizar dados do dashboard quando controlador mudar
    this.atualizarDadosDashboard();
  }

  atualizarDadosDashboard() {
    this.props.getDadosDashboard().then(result => {
      if (!result.error) {
        this.setState({
          totalControladores: parseInt(result.payload.data.total_controladores),
          totalVeiculos: parseInt(result.payload.data.total_veiculos),
          totalAlertas: parseInt(result.payload.data.total_alertas),
        });
      } else {
        toastr.error('Erro', 'Falha ao carregar dashboard.');
      }
    });
  }

  handleAlertasClick() {
    const controladorId = getConfig('cont');

    // Se "Todos" estiver selecionado (valor 0 ou vazio), redirecionar para tela geral
    if (!controladorId || controladorId === '0' || controladorId === 0) {
      this.props.history.push('/concontroladorerrogeral');
    } else {
      // Se controlador específico estiver selecionado, usar tela atual
      this.props.history.push('/concontroladorerro');
    }
  }

  valuesDashboard() {
    this.intervalValorDashboard = setInterval(() => {
      try {
        if (this.state.loop === 0) {
          this.setState({ loop: 1 });

          this.props.getDadosDashboard().then(result => {
            if (!result.error) {
              this.setState({
                totalControladores: parseInt(result.payload.data.total_controladores),
                totalVeiculos: parseInt(result.payload.data.total_veiculos),
                totalAlertas: parseInt(result.payload.data.total_alertas),
              });
            } else {
              toastr.error('Erro', 'Falha ao carregar dashboard.');
            }
            this.setState({ loop: 0 });
          });
        }
      } catch (error) {
        console.error(error);
      }
    }, 10000);
  }

  render() {
    const config = this.props.config || {};
    const moduloContagem = Boolean(config.modulo_contagem);
    // Sem contagem sobram dois cards; 4 colunas cada deixaria um vão à direita.
    const colsCard = moduloContagem ? '12 4' : '12 6';

    return (
      <div className="dashboard-container">
        <Content className="dashboard-content">
          <Row className="col-sm-12">
            <ModernValueBox
              cols={colsCard}
              position="center"
              color="blue"
              icon="server"
              value={this.state.totalControladores}
              text="Total de Controladores"
            />
            {moduloContagem && (
              <ModernValueBox
                cols={colsCard}
                position="center"
                color="green"
                icon="automobile"
                value={this.state.totalVeiculos}
                text="Total de Veículos"
                route="/contagemvolumetrica"
              />
            )}
            <ModernValueBox
              cols={colsCard}
              position="center"
              color="yellow"
              icon="warning"
              value={this.state.totalAlertas}
              text="Total de Alertas"
              onClick={this.handleAlertasClick}
            />
          </Row>

          <div>
            <Modal
              show={this.state.showFiltro}
              onHide={this.handleCloseFiltro}
              dialogClassName="modal-dialog dashboard-filter-modal"
            >
              <Modal.Header className="modal-header" closeButton>
                <Modal.Title>Filtros dos Gráficos</Modal.Title>
              </Modal.Header>

              <Modal.Body className="modal-body">
                <LabelAndInputChange
                  name="data_inicial"
                  className="modal-campo-data"
                  type="date"
                  label="Data Término Inicial"
                  cols="12"
                  value={this.state.filtroAux.dataInicial}
                  onChange={this.onChangeDataInicial}
                />

                <LabelAndInputChange
                  name="data_final"
                  className="modal-campo-data"
                  type="date"
                  label="Data Término Final"
                  cols="12"
                  value={this.state.filtroAux.dataFinal}
                  onChange={this.onChangeDataFinal}
                />
              </Modal.Body>

              <Modal.Footer className="modal-header">
                <Button type="button" className="primary" icon="check" label="Salvar" onClick={this.aplicarFiltro} />
              </Modal.Footer>
            </Modal>
          </div>

          {moduloContagem && (
          <Row className="col-sm-12">
            <Panel bsStyle="success" className="dashboard-charts-section dashboard-chart-premium">
              <Panel.Heading className="panel_heading">
                <Panel.Title componentClass="div">
                  <div className="dashboard-chart-header">
                    <div className="dashboard-chart-title">
                      <div className="dashboard-chart-icon">
                        <i className="fa fa-line-chart" />
                      </div>
                      <div>
                        <h3>Contagem volumétrica</h3>
                        <p>Total de veículos por período conforme os filtros selecionados.</p>
                      </div>
                    </div>
                    <div className="contentHeaderFilter dashboard-chart-actions">
                    <SelectConfGrupoFisico onChange={this.changeControlador} />
                    <SelectConfControlador onChange={this.changeControlador} anel={false} emptyText="Todos" />
                    <Button
                      type="button"
                      className="primary btn-sm pull-right btn_label_size"
                      icon="filter"
                      label="Filtrar Gráfico"
                      onClick={this.handleShowFiltro}
                    />
                    <Button
                      type="button"
                      className="success btn-sm pull-right btn_label_size"
                      icon="eraser"
                      label="Limpar Filtro"
                      onClick={this.limparFiltro}
                    />
                    </div>
                  </div>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <div className="dashboard-chart-shell">
                  <GraficoContagemControlador filtrosGrafico={this.state.filtro} />
                </div>
              </Panel.Body>
            </Panel>
          </Row>
          )}

          {moduloContagem && (
          <Row className="col-sm-12">
            <Panel bsStyle="success" className="dashboard-charts-section dashboard-chart-premium">
              <Panel.Heading className="panel_heading">
                <Panel.Title componentClass="div">
                  <div className="dashboard-chart-header">
                    <div className="dashboard-chart-title">
                      <div className="dashboard-chart-icon">
                        <i className="fa fa-sitemap" />
                      </div>
                      <div>
                        <h3>Contagem volumétrica por laço</h3>
                        <p>Distribuição da contagem entre os laços do controlador.</p>
                      </div>
                    </div>
                  </div>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <div className="dashboard-chart-shell">
                  <GraficoContagemLaco filtrosGrafico={this.state.filtro} />
                </div>
              </Panel.Body>
            </Panel>
          </Row>
          )}
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  summary: state.dashboard.summary,
  config: state.auth.config,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({ getSummary, getDadosDashboard, getContagemGraficoList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);
